module.exports = __webpack_public_path__ + "static/media/epinards.cbe4811e.svg";